import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconFilter } from '@sorare/core/src/atoms/icons/system/iconFilter.ts';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { useFiltersCount as useBackendFiltersCount } from '@sorare/core/src/contexts/graphql-search';
import { useFiltersCount } from '@sorare/marketplace/src/search/FiltersManager/useFiltersCount';

export const ToggleFiltersButton = ({
  toggleFilters,
}: {
  toggleFilters: () => void;
}) => {
  const filtersCount = useFiltersCount({
    countSealed: false,
    countQuery: false,
  });
  return (
    <Badge badgeContent={filtersCount} color="grey">
      <IconButton
        onClick={() => {
          toggleFilters();
        }}
        icon={iconFilter}
        size="small"
        color="transparent"
      />
    </Badge>
  );
};

export const BackendToggleFiltersButton = ({
  toggleFilters,
}: {
  toggleFilters: () => void;
}) => {
  const filtersCount = useBackendFiltersCount({
    countSealed: false,
    countQuery: false,
  });
  return (
    <Badge badgeContent={filtersCount} color="grey">
      <IconButton
        onClick={() => {
          toggleFilters();
        }}
        icon={iconFilter}
        size="small"
        color="transparent"
      />
    </Badge>
  );
};
